<template>

    <div class="bg-white p-12 shadow-sm rounded-xl mobile:p-6">

        <form class="space-y-6 " method="POST" action="/account/login/passcode" @submit.prevent="onSubmit" ref="form">
            <input v-model="returnUrl" name="returnUrl" type="hidden">
            <p v-if="error !== ''" class="text-sm text-red-400">
                {{error}}
            </p>
            
            <div v-if="!hasSubmittedEmail">
                <label for="email" class="block text-sm font-medium leading-6 text-grey-900">{{translate('email')}}</label>
                <div class="mt-2">
                    <input v-model="email" name="email" type="email" autocomplete="email">
                </div>
            </div>

            <div v-if="hasSubmittedEmail">
                <p class="mb-3 text-sm">
                    {{translate('email_sent_to')}} <span class="font-medium">{{email}}</span>
                </p>
                <p class="max-w-xs text-sm text-grey-800 mb-3">
                    {{translate('click_link_or_enter_code')}}
                </p>
                <label for="password" class="block text-sm font-medium leading-6 text-gray-900">{{translate('6_cijferige_code')}}</label>
                <div class="mt-2">
                    <input  type="text" pattern="\d*" v-model="passCode" maxlength="6" min="000000" max="999999" name="passCode" ref="passCode">
                    <input v-model="email" name="email" type="hidden">
                </div>
            </div>
            
            <button type="submit" class="btn btn-primary w-full" @click.prevent="onSubmit()">
                <span v-if="!hasSubmittedEmail">{{translate('verder')}}</span>
                <span v-else>{{translate('inloggen')}}</span>
                <i class="ml-2 far fa-arrow-right"></i>
            </button>
        </form>
        <div v-if="googleLoginPluginLoaded">
            <div class="relative mt-20">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-grey-200"></div>
                </div>
                <div class="relative flex justify-center text-sm font-medium leading-6">
                    <span class="bg-white px-6 text-grey-900">{{translate('of_meld_aan_met')}}</span>
                </div>
            </div>

            <div class="mt-6 text-center flex justify-center">
                <loading-spinner v-if="isLoading"></loading-spinner>
                <GoogleLogin v-else :buttonConfig="buttonConfig" :callback="onGoogleSuccess" prompt></GoogleLogin>
            </div>
        </div>
    </div>


    
</template>

<script lang="ts">
import {defineComponent, nextTick} from 'vue';
import Ajax from "../../lib/Ajax";
import LoadingSpinner from '../../components/loading-spinner.vue';
interface IGoogleTokenResponse{
    credential: string;
}
export default defineComponent({
    name: "login-form",
    components: {LoadingSpinner},
    props: {
      errorMessage: String
    },
    data() {
        return {
            isLoading: false,
            error: this.errorMessage ?? "",
            email: window.cw.email || "" as string,
            returnUrl: window.cw.returnUrl || "",
            hasSubmittedEmail: false,
            passCode: '',
            client_id: window.cw.clientId,
            buttonConfig: {
                width: 270,
                height: 36,
                theme: 'filled_blue'
            },
        }
    },
    computed:{
        googleLoginPluginLoaded() {
            return this.store.googleLoginPluginLoaded;  
        }   
    },
    methods: {
        onSubmit() {
            if(!this.hasSubmittedEmail)
                this.submitEmail();
            else
                this.submitPasscode();
        },
        async submitEmail() {
            if(!this.email.isValidEmailAddress()) {
                this.error = this.translate('validation_error_email');
                return;
            }
            
            try {
                await Ajax.postAsync(
                '/ajax/account/login',
                {
                    email: this.email,
                    returnUrl: this.returnUrl
                });
                
                this.hasSubmittedEmail = true;
                nextTick(() => {
                    (this.$refs['passCode']! as HTMLInputElement).focus();
                });
                this.error = '';
            } catch(e: unknown) {
                this.error = e as string;
            }
            
        
        },
        async submitPasscode() {
            if(this.passCode.length < 6) {
                this.error = this.translate('code_minimum_message');
                return;
            }

            (this.$refs.form as HTMLFormElement).submit();
        },
        onGoogleSuccess(response: IGoogleTokenResponse) {
            this.loginWithGoogle(response.credential, this.returnUrl);
        },
        async loginWithGoogle(googleTokenId: string, returnUrl = "") {
            this.isLoading = true;
            
            try {
                const redirectUrl = await Ajax.postAsync<string>(
                    '/ajax/account/login-with-google',
                    {
                        googleTokenId,
                        returnUrl
                    });

                if (redirectUrl)
                    window.location.href = redirectUrl;
                else
                    window.location.reload();
            } catch (e: unknown) {
                this.error = e as string;
            } finally {
                this.isLoading = false;
            }
        }
    }
});
</script>